module.exports = __webpack_public_path__ + "static/img/2.8894ac6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/sp/2.png
// module id = qNsh
// module chunks = 0